/// <amd-module name="Feed/Connect/Components/FirstTimeMessage" />
import * as React from "react";
import { connect } from "react-redux";

import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import * as Utils_String from "VSS/Core/Util/String";

import { ConnectToFeedActions, IConnectToFeedAwareState } from "../Redux/ConnectToFeed";
import { ITool, ToolId } from "../Tool";
import * as Res from "Feed/Connect/Resources";

export interface IFirstTimeMessageProps {
    /**
     * Class name to apply to the outer element
     */
    className?: string;

    /**
     * Tool whose first time message is being displayed.
     */
    tool: ITool;
}

interface IFirstTimeMessageOwnProps extends IFirstTimeMessageProps {
    /**
     * List of tools whose first time message have been dismissed.
     */
    dismissedTools: ToolId[];
}

const Actions = {
    onGetTools: ConnectToFeedActions.getTools,
    onDismiss: ConnectToFeedActions.dismissFirstTimeMessage
};

/**
 * Renders first time use message for the user. The message provides a shortcut to the Get the Tools pane
 * or can be dismissed on the current browser.
 */
const UnconnectedFirstTimeMessageText: React.FunctionComponent<IFirstTimeMessageOwnProps & typeof Actions> = ({
    tool,
    dismissedTools,
    className,
    onGetTools,
    onDismiss
}) => {
    if (dismissedTools.indexOf(tool.id) > -1) {
        return null;
    }

    const message = Utils_String.format(Res.FirstTimeUser, tool.name);
    const buttonProps = [
        {
            text: Res.GetTools_Text,
            onClick: () => onGetTools(tool),
            role: "button"
        }
    ];

    return (
        <MessageCard
            className={className}
            severity={MessageCardSeverity.Info}
            buttonProps={buttonProps}
            onDismiss={() => onDismiss(tool.id)}
        >
            {message}
        </MessageCard>
    );
};

function mapStateToProps(state: IConnectToFeedAwareState, ownProps: IFirstTimeMessageProps): IFirstTimeMessageOwnProps {
    return {
        ...ownProps,
        dismissedTools: state.connectToFeed.dismissedTools
    };
}

export const FirstTimeMessageText = connect(mapStateToProps, Actions)(UnconnectedFirstTimeMessageText);
